import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { MuseumState } from '@/store/types/museum.state';
import Artist from "@/models/artist";
import Artwork from "@/models/artwork";

export const getters: GetterTree<MuseumState, RootState> = {
    getArtistsSorted(state):Artist[]{
        return state.artists.sort( (a,b) => {
            let aReferenceDate;
            let bReferenceDate;

            if(a.scaleYear!=null){
                aReferenceDate = a.scaleYear;
            }else if(a.birthDate!=null){
                aReferenceDate = a.birthDate.getFullYear();
            }else{
                aReferenceDate = 0;
            }

            if(b.scaleYear!=null){
                bReferenceDate = b.scaleYear;
            }else if(a.birthDate!=null){
                bReferenceDate = b.birthDate.getFullYear();
            }else{
                bReferenceDate = 0;
            }

            return aReferenceDate - bReferenceDate; 
        });
    },
    getSortedArtworks(state):Artwork[]{
        return state.artworks.sort( (a,b) => a.date - b.date );
    }
};